<template>
    <div class="home-gdmap">
<!--        <div class="container-gdmap" :ref="id"></div>-->
        <div class="container-gdmap" :id="'container-gdmap' + id"></div>
    </div>
</template>
<script>
import AMapLoader from '@amap/amap-jsapi-loader';

export default {
    name: "mapView",
    props: {
        // 地图配置信息
        mapConfig: {
            type: Object,
            default: function() {
                return {}
            }
        },
        //- 表格数据
        tableData: {
        type: Array,
        default: ()=>[]
        },
        //- 表id
        id: {
        type: Number,
        default: 0
        },
        //- 分组字段数据
        row: {
        type: Array,
        default: ()=>[]
        },
        //- 汇总字段数据
        summary: {
        type: Array,
        default: ()=>[]
        },
        column: {
        type: Array,
        default: () => []
        }
    },
    data() {
        return {
            configData: {},
            map: null, //地图挂载
            disProvince: null, //区域地图
            adCode: 350000, // 身份/城市code
            depth: 0, //显示层级 0：省级 1：市级 3：区/县级
            centerPoint: [], //中心点坐标
            infoWindow: null
        }
    },
    watch: {
        'mapConfig':{
            immediate: true,
            handler (newV) {
                this.configData = newV;
                console.log("this.configData===",this.configData);
                console.log("this.tableData",this.tableData);

                this.initAMap();
            },
            deep:true
        },
    },
    created() {

    },
    mounted() {

    },
    methods: {
        // 地图组件初始化
        initAMap() {
            let that = this;
            AMapLoader.load({
                key: '6c0ea233b8e8bc3ed08537ee8018cb2b',  //设置您的key
                version: "2.0",
                plugins: ['AMap.PolygonEditor', 'AMap.DistrictSearch'],
                AMapUI: {
                    version: "1.1",
                    plugins: [],
                },
                Loca: {
                    version: "2.0"
                },
            }).then((AMap) => {
                let depth = that.configData.address.length-1;
                let mapZoom = (depth == 0 ? 4 : (depth == 1 ? 6 : 8)) //地图显示大小比例
                that.map = null;
                console.log("depth==",depth);
                console.log("mapZoom==",mapZoom);
                console.log("that.map==",that.map);
                console.log("that.id==",that.id, document.getElementById("container-gdmap" + that.id));
                // 初始化地图
                // that.map = new AMap.Map(that.$refs[that.id], {
              if (document.getElementById("container-gdmap" + that.id)) {
                that.map = new AMap.Map("container-gdmap" + that.id, {
                  viewMode: "3D",
                  zoom: mapZoom,
                  zooms: [2, 22],
                  center: [105.602725, 37.076636],
                });
                // that.map = new AMap.Map("container-gdmap" + that.id, {
                //     viewMode: "3D",
                //     zoom: mapZoom,
                //     zooms: [2, 22],
                //     center: [105.602725, 37.076636],
                // });
                that.map.on("complete", function(){
                  console.log("that.configData.type",that.configData.type);

                  if(that.configData.type == 'area'){
                    // 初始化完成后渲染区域地图(身份/城市code，显示层级 0：省级 1：市级 3：区/县级)
                    that.areaPro(that.configData.address[depth], depth);
                    console.log("that.map222==",that.map);
                  }
                  else{
                    that.spotPro(that.configData.address[depth], depth, AMap);
                    console.log("that.map333==",that.map);
                  }
                });
              }
            }).catch(e => {
                console.log(e);
            })
        },

        // 区域地图-渲染行政区地图
        areaPro(code, dep) {
            console.log(code, dep);
            let that = this;
            AMapLoader.load({ //可多次调用load
                plugins:['AMap.DistrictSearch']
            }).then((AMap)=>{
                // 如果选择中国，则渲染中国地图
                if(code == 100000){
                    that.disProvince && that.disProvince.setMap(null);
                    that.disProvince = new AMap.DistrictLayer.Country({
                        zIndex:12,
                        SOC:'CHN',
                        depth:1,
                        styles:{
                            'nation-stroke':'#f09',
                            'coastline-stroke':[0.85, 0.63, 0.94, 1],
                            'province-stroke':'white',
                            'city-stroke': 'rgba(255,255,255,0.15)',//中国特有字段
                            'fill': function (properties) {
                                var adcode = properties.adcode;
                                return that.getColorByAdcode(adcode);
                            },
                        }
                    })
                    let markers = that.tableData
                    that.map.clearMap(); // 清除地图覆盖物
                    // 地图上添加点标记
                    for (var i = 0; i < markers.length; i++) {
                      let cont = markers[i].title;
                      for(var j = 0; j <markers[i].content.length; j++){
                        cont += '<br/>' + markers[i].content[j]
                      }
                      let text = new AMap.Text({
                        position: new AMap.LngLat(markers[i].position[0], markers[i].position[1]),
                        text: cont,
                        offset: new AMap.Pixel(-20, -20)
                      })
                      that.map.add(text);
                      // 修改 AMap.Text 实例的样式
                      text.setStyle({
                        fontSize: 16,
                        fontWeight: 'bold',
                        fontStyle: 'italic',
                        textAlign: 'center',
                        backgroundColor: 'transparent',
                        border: 'none',
                        color: '#000000',
                        strokeWeight: 2
                      });
                    }
                    that.disProvince.setMap(that.map);
                }
                // 否则渲染省份/城市地图
                else{
                    that.dep = typeof dep == 'undefined' ? 2 : dep;
                    that.adCode = code;
                    that.depth = dep;
                    that.disProvince && that.disProvince.setMap(null);
                    that.disProvince = new AMap.DistrictLayer.Province({
                        zIndex: 12,
                        adcode: [code],
                        depth: that.dep,
                        styles: {
                            'fill': function (properties) {
                                var adcode = properties.adcode;
                                return that.getColorByAdcode(adcode);
                            },
                            'province-stroke': 'cornflowerblue',
                            'city-stroke': 'white', // 中国地级市边界
                            'county-stroke': 'rgba(255,255,255,0.5)' // 中国区县边界
                        }
                    });
                    console.log(55555);
                    let markers = that.tableData
                    that.map.clearMap(); // 清除地图覆盖物
                    // 地图上添加点标记
                    for (let i = 0; i < markers.length; i++) {
                        let cont = markers[i].title;
                        for(let j = 0; j <markers[i].content.length; j++){
                            cont += '<br/>' + markers[i].content[j]
                        }
                        let text = new AMap.Text({
                            position: new AMap.LngLat(markers[i].position[0], markers[i].position[1]),
                            text: cont,
                            offset: new AMap.Pixel(-20, -20)
                        })
                        that.map.add(text);
                        // 修改 AMap.Text 实例的样式
                        text.setStyle({
                            fontSize: 16,
                            fontWeight: 'bold',
                            fontStyle: 'italic',
                            textAlign: 'center',
                            backgroundColor: 'transparent',
                            border: 'none',
                            color: '#000000',
                            strokeWeight: 2
                        });
                    }

                    that.disProvince.setMap(that.map);
                    console.log(66666,that.configData.initialAddress);

                    that.map.setCenter(that.configData.initialAddress);
                    console.log(77777);

                }
            }).catch((e)=>{
                console.error(e);
            });
        },
        // 渲染区域地图随机颜色
        getColorByAdcode (adcode) {
            var colors = {};
            if (!colors[adcode]) {
                var gb = Math.random() * 155 + 50;
                colors[adcode] = 'rgb(' + gb + ',' + gb + ',255)';
            }
            return colors[adcode];
        },
        // 点地图
        spotPro(code, dep, AMap) {
            let that = this;
            // 信息窗体
            that.infoWindow = new AMap.InfoWindow({offset: new AMap.Pixel(0, -40)});
            // 渲染点坐标
            let markers = that.tableData
            console.log("markers==",markers);

            that.map.clearMap(); // 清除地图覆盖物

            // 地图上添加点标记
            for (var i = 0, marker; i < markers.length; i++) {
                marker = new AMap.Marker({
                    position: markers[i].position,
                    map: that.map
                });
                marker.content = '<h6 class="info-gdtitle">' + markers[i].title + '</h6>';
                for(var j = 0; j < markers[i].content.length; j++){
                    marker.content += '<p class="info-gdcont">' + markers[i].content[j] + '</p>'
                }
                marker.on('click', that.markerClick);
                // marker.emit('click', {target: marker});
            }
            // 设置中心点坐标
            // that.map.setCenter(that.configData.initialAddress);
            if(that.configData.center == 'auto'){
                console.log("aaa");

                that.map.setFitView();
            }
            else{
                console.log("bbb")
                if(code == 100000){
                    that.map.setCenter([105.602725, 37.076636]);
                }
                else{
                    that.map.setCenter(that.configData.initialAddress);
                }
            }
        },
        markerClick(e) {
            this.infoWindow.setContent(e.target.content);
            this.infoWindow.open(this.map, e.target.getPosition());
        }
    }
}
</script>
<style>
.home-gdmap {
    padding: 0px;
    margin: 0px;
    width: 100%;
    height: 100%;
    position: relative;
}

.container-gdmap {
    padding: 0px;
    margin: 0px;
    width: 100%;
    height: 100%;
    position: absolute;
}

.info-gdtitle {
    font-size:13px;
    color: #333;
    line-height: 22px;
}

.info-gdcont {
    position: relative;
    font-size: 12px;
    color: #999;
    line-height: 20px;
    padding-left: 15px;
}

.info-gdcont:after {
    content: '';
    position: absolute;
    left: 0;
    top: 5px;
    display: block;
    width: 8px;
    height: 8px;
    background: #bfbfbf;
    border-radius: 50%;
}
</style>
